import _objectSpread from "@babel/runtime/helpers/objectSpread2";
// 这里改用 ua 的仓库
import ua from '@tencent/docs-user-agent';
import * as openDocAction from "./actions";
import { getMultiUrl, isQQDomain, preprocessUrl, getPreprocessUrl, triggerAnchorClick } from "./utils";
import { getCurrentWindow } from "./utils/window";
import DefaultConfiguration from "./utils/configuration";
/**
 * 端上详情页，微盘的链接需要用特殊的 jsapi 打开
 * 微盘的链接需要调一个接口，判断要不要用
 */

var isIPad = ua.isIPad,
    isMobile = ua.isMobile,
    isMiniProgram = ua.isMiniProgram,
    isWxMiniProgram = ua.isWxMiniProgram,
    isQQMiniProgram = ua.isQQMiniProgram,
    isTimOrQQ = ua.isTimOrQQ,
    isIOS = ua.isIOS,
    isWeChat = ua.isWeChat,
    isWxWork = ua.isWxWork,
    isTencentDocsApp = ua.isTencentDocsApp,
    isPCTencentDocsClient = ua.isPCTencentDocsClient,
    isIE = ua.isIE,
    isSafari = ua.isSafari,
    isElectronTencentDocsClient = ua.isElectronTencentDocsClient,
    isQQDesktopDocsClient = ua.isQQDesktopDocsClient,
    isWxDrive = ua.isWxDrive;

/**
 * 注册部分通用配置
 * @param options 需要注入的全局配置，将会覆盖一部分默认逻辑，包括跳过 中转页的检查和哪些域名忽略中转页
 */
export function setDefaultConfiguration(options) {
  DefaultConfiguration.register(options);
}
/**
 * doc 的已有导出
 */

export var getMultUrl = getMultiUrl;
export function newBlankWindow() {
  if (isWxMiniProgram || isQQMiniProgram) {
    return 'miniProgram';
  }

  return window.open();
}
/**
 * window.open的封装
 * @param {string}} url
 */

export function openNewBlankWindow(url) {
  var theUrl = getMultiUrl(url);
  return window.open(theUrl);
}
export function tencentDocOpenUrlReload() {
  tencentDocOpenUrlForAll({
    url: location.href,
    replace: true
  });
}
export function setNewWindowUrl(windowObject, url) {
  if (windowObject === 'miniProgram') {
    tencentDocOpenUrlForAll({
      url: url
    });
    return;
  }

  if (!url) {
    return;
  }

  var theUrl = preprocessUrl(url);

  if (windowObject) {
    windowObject.location = theUrl;
  } else if (theUrl) {
    window.location.href = theUrl;
  }
}
export function isNeedScenarioRedirectLink(url, options) {
  return !isQQDomain(url) && !(options !== null && options !== void 0 && options.ignoreDomainDetect);
}
/**
 *
 * @param options
 * @param options.url 要打开的 url，比如 https://docs.qq.com/sheet/xxx 这样，支持自动识别详情页，打开 detail 容器，支持自动补充 https 头
 * @param options.wxUrl 指定小程序页面 url （参数要调用方组织好），比如 /pages/xxx/xxx?a=1&b=2 注意参数是否需要编码
 * @param options.replace 是否在当前页打开。true 代表是在当前页打开
 * @param options.ignoreDomainDetect 忽略域名校验。默认是要通过 scenario 校验域名的
 * @param options.windowName?: string window.open 第二个参数
 * @param options.windowFeatures?: string window.open 第三个参数
 * @param options.noUserIndex?: boolean 是否需要带u
 * @param options.noHistory?: boolean 是否要清history
 * @param options.useNewConfig?: boolean qq接口的参数
 * @param options.supportIFrame?: boolean 是否兼容 iframe 情况, 如果是 true，则支持 iframe 嵌套，会优先使用 window.top 及其 mqq 和  wx 对象
 * @param options.safariNeedReplace?: boolean safari 强制在当前页面刷新
 * @param options.appConfig?: app 中 openUrl相关的配置
 */

export function tencentDocOpenUrlForAll(options) {
  var url = options.url,
      wxUrl = options.wxUrl,
      replace = options.replace,
      style = options.style,
      safariNeedReplace = options.safariNeedReplace;

  var _ref = getPreprocessUrl(url, options) || {},
      targetUrl = _ref.url,
      callback = _ref.callback;

  if (!targetUrl) {
    return;
  } // 有指定忽略中转页的处理方式，


  if (callback) {
    callback(function () {
      openUrl(targetUrl, _objectSpread({
        ignoreDomainDetect: true
      }, options));
    });
    return;
  }

  console.log('open_url 参数》》》》》》', targetUrl, wxUrl, replace, isWxMiniProgram, isQQMiniProgram, isTimOrQQ, isIOS, isMobile, isIPad, isIE, window.mqq, style, safariNeedReplace, options, getPreprocessUrl(url, options));
  openUrl(targetUrl, options);
}
export function tencentDocOpenUrl(url, name, specs, replace) {
  if (url === undefined) {
    return;
  }

  var theUrl = preprocessUrl(url); // IE很特殊，主动触发不生效
  // 但是IE又不会有同一个进程的问题，所以IE就走默认的window.open

  if (!isMobile && !isIE) {
    var a = document.createElement('a');
    a.href = theUrl; // PC微信小程序不支持新窗口打开，所以只能进行自身跳转

    if (!isMobile && isMiniProgram) {
      name = '_self';
    }

    a.target = name ? name : '_blank'; // 核心，断掉referrer

    a.rel = 'noreferrer';
    triggerAnchorClick(a);
  } else {
    // 移动端和IE还走之前的逻辑
    window.open.apply(window, [url, name, specs, replace]); // window.open.apply(window, arguments);
  }
}
/**
 * 真正打开页面的逻辑
 * @param targetUrl
 * @param options
 */

function openUrl(targetUrl, options) {
  var supportIFrame = options.supportIFrame,
      safariNeedReplace = options.safariNeedReplace,
      isDownLoad = options.isDownLoad;
  var currentWindow = getCurrentWindow(supportIFrame);
  var isNative = isTimOrQQ || isTencentDocsApp || isElectronTencentDocsClient || isQQDesktopDocsClient;

  if (isDownLoad && isNative) {
    openDocAction.doOpenUrlForDownload(targetUrl);
  } else if (isWxMiniProgram || isQQMiniProgram) {
    openDocAction.doOpenUrlForMiniProgram(targetUrl, options);
  } else if (isWeChat || isSafari && safariNeedReplace) {
    // 微信 H5 是不允许新开页面的，只能在当前页跳转
    currentWindow.location.href = targetUrl; // 这里排除 Electron 客户端，因为mini版本也会跑这来。
  } else if (isTimOrQQ || isTencentDocsApp) {
    openDocAction.doOpenUrlForQQorDocApp(targetUrl, options);
  } else if (isWxWork || isWxDrive) {
    openDocAction.doOpenUrlForWxworkOrWedrive(targetUrl, options);
  } else if (isIE) {
    openDocAction.doOpenUrlForIE(targetUrl, options);
  } else if (isPCTencentDocsClient) {
    openDocAction.doOpenUrlForPCDocClient(targetUrl, options);
  } else {
    openDocAction.doOpenUrlForOther(targetUrl, options, currentWindow);
  }
}